export default __webpack_public_path__ + "static/media/blueLoader.8933cdb4.svg";